import { flattenReduxFormProps } from 'decorators';
import { SliderInput } from 'components/form/SliderInput';

export default flattenReduxFormProps(SliderInput);
